import React from "react";
import { graphql, useStaticQuery } from "gatsby"
import MenuItem from "@material-ui/core/MenuItem"
import { Typography, useMediaQuery } from "@material-ui/core"
import Colors from "../../constants/Colors"
import Select from "@material-ui/core/Select"
import InputLabel from "@material-ui/core/InputLabel"
import {fromJS} from 'immutable';
import clsx from "clsx"
import { blue } from "@material-ui/core/colors"
import useTheme from "@material-ui/core/styles/useTheme"


export default function({primary,
                          secondary,
                          value,
                          defaultColor,
                          updateValue,
                          rootStyle,
                          selectMenuProps,
                          selectClasses,
                          menuItemClasses,
                          iconColor,
                          textColor,
                          blueText,
                          iOS
}) {

  const data = useStaticQuery(graphql`
    query CommunityResourceTypesQuery {
      allDatoCmsCommunityResource {
        edges {
          node {
            category
          }
        }
      }
    }
  `)
  const theme = useTheme();
  const uniqueResourceTypes = fromJS(data.allDatoCmsCommunityResource.edges.flatMap(e => e.node)).map(f => f.get('category')).toSet().toList().sort();
  const smallBreakpoint = useMediaQuery(theme.breakpoints.down('xs'));
  const applyNative = smallBreakpoint || iOS

  return(
    <div style={{...rootStyle}}>
      <Select
        native={applyNative}
        fullWidth
        disableUnderline
        onChange={e => updateValue(e.target.value)}
        MenuProps={selectMenuProps}
        classes={selectClasses}
        value={value}
        className={clsx("state-select-hook", blueText ? "state-select-bluetext" : null)}
        style={{marginLeft: smallBreakpoint ? 0 : null}}
      >
        {
          !applyNative && uniqueResourceTypes &&
          <MenuItem value="none">
            <Typography variant="h6"
              style={{
                marginBottom: "2px !important",
                fontFamily: "Lato, Verdana, sans-serif;",
                fontWeight: "Bold",
                color: textColor ? textColor : Colors.azure,
                textTransform: "none",
              }} >Select resource category</Typography>
          </MenuItem>
        }
        {
          !applyNative && uniqueResourceTypes && uniqueResourceTypes.map((uniqueResourceType) => {
          return(
          <MenuItem value={uniqueResourceType} classes={menuItemClasses} >
            <Typography variant="h6" style={{
            fontFamily: "Lato, Verdana, sans-serif",
            fontWeight: "bold",
            color: textColor ? textColor : Colors.azure,
            textTransform: "none"}}>
              {uniqueResourceType}
            </Typography>
          </MenuItem>
          )
          })
        }
        {
          applyNative &&
            <option style={{color: textColor ? textColor : Colors.azure}}>
              Select resource category
            </option>
        }
        {
          applyNative && uniqueResourceTypes.map((uniqueResourceType) => (
            <option value={uniqueResourceType} style={{color: textColor ? textColor : Colors.azure}}>
              {uniqueResourceType}
            </option>
          ))
        }
      </Select>
    </div>
  )
}
